import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataFiltersService } from './data-filters.service';
import { RegionSelection } from '../models/region-selection.model';
import { regionsMap } from '../../../regions';
import { Region } from '../models/region-model';

type BreadCrumbType<T> = T & {name: string, code?: string}

@Injectable()
export class BreadcrumbsService {
    private ngUnsubscribe: Subject<void> = new Subject();
    constructor(private dataFiltersService: DataFiltersService){
        this.dataFiltersService
        .getDataFilters()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((filters) => {
            this.updateBreadcrumbs(filters.regionSelection)
        });
    }

    private _breadcrumbsMap = new Map<string, BreadCrumbType<RegionSelection | Region>>();
    get breadcrumbsMap(): ReadonlyMap<string, BreadCrumbType<RegionSelection | Region>> {
      return this._breadcrumbsMap;
    }
  
    private _breadcrumbs$ = new BehaviorSubject<ReadonlyMap<string, BreadCrumbType<RegionSelection | Region>>>(this.breadcrumbsMap);
    get breadcrumbs$() {
      return this._breadcrumbs$.asObservable();
    }

    updateBreadcrumbs(regions: RegionSelection){
        this.clearBreadcrumbs();
        if(regions.countries.size === 1){
            regionsMap.forEach(region => {
                if(region.countries.some(country => country === regions.countries.entries().next().value[1].code)){
                    this._breadcrumbsMap.set('continent', region);
                    this._breadcrumbsMap.set('country', regions.countries.entries().next().value[1])
                }
            })
            if(regions.cities.size === 1){
                this._breadcrumbsMap.set('city', regions.cities.entries().next().value[1])
            }
            return;
        }
        if(regions.regions.size === 1){
            this._breadcrumbsMap.set('continent', regions.regions.entries().next().value[1])
        }
    }
    
    clearBreadcrumbs(){
        this._breadcrumbsMap.clear()
    }
    

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
